import { IP360PartnerFlags } from 'partner360/models/p360PartnerFlags/IP360PartnerFlags'
import { IReportPartner } from 'partner360/models/report/IReportPartner'

export const getMarketCoverage = (
  coverage: IReportPartner['Coverage'],
  flag: IP360PartnerFlags
): number | null => {
  if (!coverage) {
    return null
  }
  try {
    const entries: unknown = typeof coverage === 'string' ? JSON.parse(coverage) : coverage
    if (!Array.isArray(entries)) {
      return null
    }
    const entry = entries.find((item) => item?.TopFlag === flag.PartnerFlag)
    return typeof entry?.MarketCoverage === 'number' && Number.isFinite(entry.MarketCoverage)
      ? entry.MarketCoverage
      : null
  } catch {
    return null
  }
}

export const formatMarketCoverage = (value: number) => `${Number(value.toFixed(1))}%`
